/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { bulkContactResultsResponseDtoSchema } from "../bulkContactResultsResponseDtoSchema";
import { bulkDeleteContactsDtoSchema } from "../bulkDeleteContactsDtoSchema";
import { z } from "zod/v4";

export const deleteContactsHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Deletes up to 1,000 contacts. Each contact is deleted independently, so a missing or failing one does not affect the others; the response has one result per distinct contact ID. POST rather than DELETE, since many clients and proxies drop the body of a DELETE request.
 */
export const deleteContacts200Schema = z.lazy(() => bulkContactResultsResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const deleteContacts401Schema = z.any()

export const deleteContactsMutationRequestSchema = z.lazy(() => bulkDeleteContactsDtoSchema)

export const deleteContactsMutationResponseSchema = z.lazy(() => deleteContacts200Schema)